import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VueCookie from 'vue-cookie';
import App from "./App";
import VueFilterDateFormat from 'vue-filter-date-format'
import vuetify from './plugins/vuetify';
import Paginate from 'vuejs-paginate'
import Notifications from 'vue-notification';
import VueTelInput from "vue-tel-input";
import 'vue-tel-input/dist/vue-tel-input.css';
window.axios = require('axios');
// axios.defaults.baseURL = process.env['VUE_APP_API_URL'];
axios.interceptors.response.use(res => {
  return res;
}, err => {
  return Promise.reject(err.response);
});

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueCookie);
Vue.use(VueTelInput);
Vue.use(Notifications)
Vue.use(VueFilterDateFormat);
Vue.component('paginate', Paginate)
import Index from './views/Index.vue';
import IndexPro from './views/IndexPro.vue';
import Playlist from './views/Playlist.vue';
import "./styles/main.scss";
// import AutoMail from './views/AutoMail.vue';
import PlaylistEdit from './views/PlaylistEdit.vue';
import SendNotification from './views/SendNotification.vue'
import Gifts from './views/Gifts.vue';
import Login from './views/Login.vue';
import Workshop from './views/Workshop.vue';
import Funkit from './views/Funkit.vue';
import Shootlist from './views/Shootlist.vue';
import ShootlistEdit from './views/ShootlistEdit.vue';
import EventCategories from './views/EventCategories.vue';
import PlaylistLocations from './views/PlaylistLocations.vue';
import PlaylistSections from './views/PlaylistSections.vue';
import School from './views/School.vue';
import Users from './views/Users.vue';
import UsersPro from './views/UsersPro.vue';
import Parent from './views/Parent.vue';
import Funzone from './views/Funzone.vue';
import GiftPopular from './views/GiftPopular.vue';
import GiftType from './views/GiftType.vue';
import Types from './views/Types.vue';
import DirTargets from './views/DirTargets.vue';
import ShootlistCategory from './views/ShootlistCategory.vue';
import GiftSevenPage from './views/GiftSevenPage.vue';
import GiftSevenPageCategory from './views/GiftSevenPageCategory.vue';
import GiftEightPage from './views/GiftEightPage.vue';
import GiftEightPageCategory from './views/GiftEightPageCategory.vue';
import GiftNinePage from './views/GiftNinePage.vue';
import GiftNinePageCategory from './views/GiftNinePageCategory.vue';
import GiftTenPage from './views/GiftTenPage.vue';
import GiftTenPageCategory from './views/GiftTenPageCategory.vue';
import GiftElevenPage from './views/GiftElevenPage.vue';
import GiftElevenPageCategory from './views/GiftElevenPageCategory.vue';
import GiftTwelvePage from './views/GiftTwelvePage.vue';
import GiftTwelvePageCategory from './views/GiftTwelvePageCategory.vue';
import EncryptedPromos from './views/EncryptedPromos.vue';
import GiftPopularCategory from './views/GiftPopularCategory.vue';
import LanguagesList from "./views/LanguagesList.vue";
import GiftMatchedGames from './views/GiftMatchedGames';
import GiftMatchedGamesCategory from './views/GiftMatchedGamesCategory';
import GiftFromChores from './views/GiftFromChores';
import GiftFromChoresCategory from './views/GiftFromChoresCategory';
import GiftSociallSkills from './views/GiftSociallSkills';
import GiftSociallSkillsCategory from './views/GiftSociallSkillsCategory';
import GiftLearningSkills from './views/GiftLearningSkills';
import GiftLearningSkillsCategory from './views/GiftLearningSkillsCategory';
import PagesTitlesList from './views/pagesTitles/PagesTitlesList';
import UserRegistration from './views/UserRegistration.vue';
import UserRegistrationPro from './views/UserRegistrationPro.vue';
import TreatmentGoals from './views/TreatmentGoals.vue';
import TreatmentSubGoals from './views/TreatmentSubGoals.vue';

//PRO VERSION TEMPLATES AND PAGES

import PlaylistLocationsPro from './views/PlaylistLocationsPRO.vue';
import PlaylistEditPRO from './views/PlaylistEditPRO.vue';
import PlaylistPRO from './views/PlaylistPRO.vue';
import Like from './views/Like.vue';
import Dislike from './views/Dislike.vue';
import Organization from './views/Organization.vue';
import Specialties from './views/Specialties.vue';
import PlaylistTips from './views/PlaylistTips.vue'
import TeamUsers from './views/TeamUsers.vue';
import ZoomUsers from './views/ZoomUsers.vue';
import PlaydateQuestions from './views/PlaydateQuestions.vue';
import PlaydateCeremonies from './views/PlaydateCeremonies.vue';
import PlaylistSortsPRO from './views/PlaylistSortsPRO.vue';
import PlaylistSorts from './views/PlaylistSorts.vue';
import InfoPage from './views/InfoPage.vue';
const router = new VueRouter({
  routes: [
    //PRO VERSION ROUTES
    {path:'/playlist-sorts', component: PlaylistSortsPRO, name: 'PlaylistSorts'},
    {path:'/info-page', component:InfoPage, name:'InfoPage'},
    {path:'/playdate-ceremonies', component:PlaydateCeremonies,name:'playdateCeremonies'},
    {path:'/playdate-questions', component:PlaydateQuestions,name:'playdateQuestions'},
    {path:'/playlist-tips', component:PlaylistTips, name:'playlistTips'},
    {path:'/team-users', component:TeamUsers, name:'teamUsers'},
    {path:'/zoom-users', component:ZoomUsers, name:'zoomUsers'},
    {path:'/playdate-pro', component:PlaylistPRO, name:'playlistProm'},
    { path: '/playdate-pro/:id_playlist', component: PlaylistEditPRO, name: 'playlist-edit-pro' },
    {path:'/playlist/locations-pro', component:PlaylistLocationsPro, name:'playlistLocations-pro'},
    {path:'/likes', component:Like, name:'likes'},
    {path:'/dislikes', component:Dislike, name:'dislikes'},
    {path:'/organization', component:Organization, name:'organization'},
    { path: '/indexpro', component: IndexPro, name: 'indexpro' },
    { path: '/specialties', component: Specialties, name: 'specialties' },
    { path: '/userspro', component: UsersPro, name: 'userspro' },
    //OLD VERSION
    {path:'/playlist-sorts-orig', component: PlaylistSorts, name: 'PlaylistSortsOrig'},
    {path:'/register', component:UserRegistration, name: 'register'},
    {path:'/registerPro', component:UserRegistrationPro, name: 'registerPro'},
    { path: '/', component: Index, name: 'index' },
    { path: '/treatment-goals', component: TreatmentGoals, name: 'treatment-goals' },
    { path: '/treatment-subgoals', component: TreatmentSubGoals, name: 'treatment-subgoals' },
    { path: '/login', component: Login, name: 'login' },
    { path: '/encoded', component: EncryptedPromos, name: 'encoded' },
    { path: '/sendNotification', component: SendNotification, name: 'notifications' },
    { path: '/playlist', component: Playlist, name: 'playlist' },
    { path: '/playlist/locations', component: PlaylistLocations, name: 'playlist-locations' },
    { path: '/playlist/sections', component: PlaylistSections, name: 'playlist-sections' },
    { path: '/playlist/:id_playlist', component: PlaylistEdit, name: 'playlist-edit' },
    { path: '/gifts', component: Gifts, name: 'gifts' },
    { path: '/workshop', component: Workshop, name: 'workshop' },
    { path: '/shootlist', component: Shootlist, name: 'shootlist' },
    { path: '/shootlist_category', component: ShootlistCategory, name: 'ShootlistCategory' },
    { path: '/shootlist/:id_shootlist', component: ShootlistEdit, name: 'shootlist-edit' },
    { path: '/funkit', component: Funkit, name: 'funkit' },
    { path: '/event/categories', component: EventCategories, name: 'event-categories' },
    { path: '/school', component: School, name: 'school' },
    { path: '/users', component: Users, name: 'users' },
    { path: '/parent', component: Parent, name: 'parent' },
    { path: '/funzone', component: Funzone, name: 'funzone' },
    { path: '/gift_popular', component: GiftPopular, name: 'gift_popular' },
    { path: '/education_category', component: GiftPopularCategory, name: 'GiftPopularCategory' },
    { path: '/matched_games', component: GiftMatchedGames, name: 'matched_games' },
    { path: '/matched_games_category', component: GiftMatchedGamesCategory, name: 'matched_games_category' },

    { path: '/seven_page', component: GiftSevenPage, name: 'seven_page' },
    { path: '/seven_page_category', component: GiftSevenPageCategory, name: 'seven_page_category' },

    { path: '/eight_page', component: GiftEightPage, name: 'eight_page' },
    { path: '/eight_page_category', component: GiftEightPageCategory, name: 'eight_page_category' },

    { path: '/nine_page', component: GiftNinePage, name: 'nine_page' },
    { path: '/nine_page_category', component: GiftNinePageCategory, name: 'nine_page_category' },

    { path: '/ten_page', component: GiftTenPage, name: 'ten_page' },
    { path: '/ten_page_category', component: GiftTenPageCategory, name: 'ten_page_category' },

    { path: '/eleven_page', component: GiftElevenPage, name: 'eleven_page' },
    { path: '/eleven_page_category', component: GiftElevenPageCategory, name: 'eleven_page_category' },

    { path: '/twelve_page', component: GiftTwelvePage, name: 'twelve_page' },
    { path: '/twelve_page_category', component: GiftTwelvePageCategory, name: 'twelve_page_category' },







    { path: '/from_chores', component: GiftFromChores, name: 'from_chores' },
    { path: '/from_chores_category', component: GiftFromChoresCategory, name: 'from_chores_category' },
    { path: '/sociall_skills', component: GiftSociallSkills, name: 'sociall_skills' },
    { path: '/sociall_skills_category', component: GiftSociallSkillsCategory, name: 'sociall_skills_category' },
    { path: '/learning_skills', component: GiftLearningSkills, name: 'learning_skills' },
    { path: '/learning_skills_category', component: GiftLearningSkillsCategory, name: 'learning_skills_category' },
    { path: '/gift_type', component: GiftType, name: 'gift_type' },
    { path: '/types', component: Types, name: 'types' },
    { path: '/dir-targets', component: DirTargets, name: 'dir-targets' },
    { path: '/lang-list', component: LanguagesList, name: 'lang-list' },
    { path: '/pages-title-list', component: PagesTitlesList, name: 'pages-title-list' },
  ]
});

const store = new Vuex.Store({
  state: {

  },
  mutations: {

  }
});

const app = new Vue({
  render: h => h(App),
  router,
  store,

  data: {
    logged: false,
    loaded: false,
  },
  created() {

    let prevState = localStorage.getItem('prevState');
    if(prevState!=null)
    {
      if(prevState=="true")
      {
        axios.defaults.baseURL = process.env['VUE_APP_API_URL_PROD'];
        localStorage.setItem('prevState',true);
      }
      else
      {
        axios.defaults.baseURL = process.env['VUE_APP_API_URL'];
        localStorage.setItem('prevState',false);
      }
    }
    else
    {
      axios.defaults.baseURL = process.env['VUE_APP_API_URL'];
      localStorage.setItem('prevState',false);
    }

    if (this.$cookie.get('auth')) {
      axios.defaults.headers.common['Authorization'] = this.$cookie.get('auth');
      axios.get('/user/infoAdmin').then(res => {
        this.logged = true;
      }).catch(res => {
        this.logged = false;
        this.$router.push('/login');
      }).finally(res => {
        this.loaded = true;
      });
    } else {
      this.logged = false;
      this.$router.push('/login');
    }
  },

  vuetify,

  mounted() {

  }
}).$mount("#app");


router.beforeEach((to, from, next) => {

    if (!app.logged && app.loaded) {
      next('/login');
    } 
    else if(to.name == 'index')
    {
      // Получение текущего URL
      var currentUrl = axios.defaults.baseURL;

      // Строка, которую вы хотите проверить
      var searchString = "playdate.pro";

    // Проверка наличия строки в текущем URL
      if (currentUrl.includes(searchString)) {
        next('/indexpro');
      } else {
        console.log('no');
        next();
      }
    }
    else {
    next();
  }
});
